// @ts-nocheck
import { adjustmentService, hubService, storeService, } from '@/services';
import HubDetailVM from '@/view-model/hub/HubDetailVM';
import StoreAdjustmentDetailVM from '@/view-model/store-adjustment/StoreAdjustmentDetailVM';
import StoreAdjustmentVM from '@/view-model/store-adjustment/StoreAdjustmentVM';
export default {
    resetStoreAdjustmentDetail({ commit }) {
        commit('RESET_STORE_ADJUSTMENT_DETAIL');
    },
    /**
     * 공급내역
     * @param {} param
     */
    async getStoreAdjustmentDetail({ commit }, { storeId, hubId, fromAt, toAt, }) {
        try {
            const res = await adjustmentService.getStoreAdjustmentDetail({
                storeId,
                hubId,
                fromAt,
                toAt,
            });
            res.data = res.data.map((detail) => new StoreAdjustmentDetailVM(detail));
            commit('GET_PROVIDE_LIST', res.data);
            return res.data;
        }
        catch (error) {
            console.log('[store-adjustment-detail getStoreAdjustmentDetail]', error);
            return error;
        }
    },
    /**
     * 공급자
     */
    async getHubDetail({ commit }, hubId) {
        try {
            const res = await hubService.getHub(hubId);
            res.data = new HubDetailVM(res.data);
            commit('GET_PROVIDER_INFO', res.data);
        }
        catch (error) {
            console.log('[getHubDetail]', error);
        }
    },
    /**
     * 공급받는자
     */
    async getStoreDetail({ commit }, storeId = '') {
        try {
            const res = await storeService.getStoreDetail(storeId);
            res.data = new StoreAdjustmentVM(res.data);
            commit('GET_CONSUMER_INFO', res.data);
            return res.data;
        }
        catch (error) {
            console.log('[getStoreDetail]', error);
            return error;
        }
    },
};
